
import React, { useContext } from 'react';
import Inputs from 'components/inputs/inputs';
import { Form } from 'react-bootstrap';
import BoardingContext from 'components/navigation/boarding/boardingContext';

export default function BoardingOrderInformation(props) {
  return <OrderNotesForm />;
}

function OrderNotesForm(props) {
  const { boardingState, updateOrder } = useContext(BoardingContext);
  const data = boardingState.data.order || {};

  const updateField = (field, value) => {
    let newData = { ...data };
    newData[field] = value;
    updateOrder(newData);
  };

  return (
    <Form.Group>
      <Form.Label>Special Instructions</Form.Label>
      <Inputs.TextArea placeholder='Please enter any special instructions' value={data.notes} onValueChange={(v) => updateField('notes', v)} rows='5' />
    </Form.Group>
  );
}